export default {
  SITTER: {
    id: 4,
  },
  PARENT: {
    id: 5,
  },
  AGENCY: {
    id: 9,
  },
  SUPER_USER: {
    id: 11,
  },
  PAYMENT_ADMIN: {
    id: 30,
  },
  SECURITY_ADMIN: {
    id: 31,
  },
  MANAGER_ADMIN: {
    id: 32,
  },
  PRODUCT_ADMIN: {
    id: 33,
  },
  AGENCY_ADMIN: {
    id: 34,
  },
};
